function stickyHeader() {
    // grab the initial top offset of the navigation 
    var stickyNavTop = $('header.site-header').offset().top;
    // our function that decides weather the navigation bar should have "fixed" css position or not.
    var stickyNav = function() {
        var scrollTop = $(window).scrollTop(); // our current vertical position from the top
        // if we've scrolled more than the navigation, change its position to fixed to stick to top,
        // otherwise change it back to relative
        if (scrollTop > stickyNavTop) {
            $('body').addClass('nav-sticky');
        } else {
            $('body').removeClass('nav-sticky');
        }
    };
    stickyNav();
    // and run it again every time you scroll
    $(window).scroll(function() {
        stickyNav();
    });
}

function accordion() {
    $("div.accordion h3.title").on("click", function() {
        if ($(this).hasClass('is-open')) {
            $(this).stop().removeClass("is-open");
            $(this).next("div.content").stop().slideUp();
        } else {
            $("div.accordion h3.title").stop().removeClass("is-open");
            $("div.accordion h3.title").stop().next("div.content").stop().slideUp();
            $(this).addClass("is-open").stop().next("div.content").stop().slideDown();
        }
        var prevItem = $(this).parents("div.item").prev('div.item');
        if ((prevItem).length > 0) {
            var prevPos = prevItem.offset().top;
            $("body, html").animate({
                scrollTop: prevPos - 100
            });
        }
    });
}
// Window Resize -------------------------------
$(window).resize(function() {
    var winWidth = $(window).width();
    if (winWidth >= 768) {
        $("div.scroller").removeClass("mobile-view").addClass("desktop-view");
    } else {
        $("div.scroller").removeClass("desktop-view").addClass("mobile-view");
    }
});

// Document Ready -------------------------------
$(document).ready(function() {
  	//countrydropdown 
  $(".country-link-wrap .dropdown-arrow").on("click", function(){    
    if ($(this).hasClass("active")) {
       $(this).removeClass("active");
	  $(".dropdown-menu .dropdown-items").removeClass("open");
    }
    else{
      	 $(this).addClass("active");
    	$(".dropdown-menu .dropdown-items").addClass("open");		
    }	
  });
    // covid js
    jQuery('.covid a').on('click', function(e){
      jQuery('body').addClass('covid-body');
      e.preventDefault();
    });
    jQuery('.covid-close').on('click', function(){
      jQuery('body').removeClass('covid-body');
    });
    // Home page Hero banner text flip animation ---------------------
    setTimeout(function() {
        $(".front-banner .cd-words-wrapper").css("display", "inline-block");
        var animateText = setInterval(myTimer, 3000);

        function myTimer() {
            $("span.animated-word").each(function() {
                $(this).find('b').addClass('in');
            });
        }
        $(".front-banner span.default-text").css("display", "none");
    }, 1500);
    // $("#MobileNav li:first-child ul.mobile-nav__dropdown").css("display", "block");
    $("ul.site-nav li.site-nav--has-dropdown button").on("click", function() {
        $(this).next("div.site-nav__dropdown").stop().toggleClass('sub-nav-open');
    });
    scroller();
    
    stickyHeader();
    var collapse = check('div.accordion');
    if (collapse > 0) {
        accordion();
    }
    // Mobile Accordion -------------------------
    $("div.mobile-accordion").on("click", "h3.accordion-title", function() {
        $(this).toggleClass("open");
        $(this).parents("div.mobile-accordion").next("div.mobile-accordion-content").toggleClass('is-open');
    });
    // Toggle Nav Open ---------------------------
    $("button.js-mobile-nav-toggle").on("click", function() {
        $("header.site-header").toggleClass("nav-open");
    });
    var winWidth = $(window).width();
    if (winWidth <= 768) {
    // Media coverage logo 3 items wrap in single row ----------
      $('.press-coverage .logos > .flex-container').removeClass('flex-container').addClass('mobile-view');
    var wrapIT = $('.press-coverage .logos').find('div.item');    
      for(var i=0, len = wrapIT.length; i < len; i+=3){
          wrapIT.slice(i, i+3).wrapAll('<div class="flex-container"/>');
      } 
    }

  //Send activation email if the customer is not enabled yet.
  $("#btnSignin").on('click', function(e){
      $('#btnSignin').attr("disabled", true);
      $('.form-message').addClass('hide');
      $.ajax({
          url: "https://app.dimplecontacts.com/middleware/subscription/checkcustomerlogin",
          type: "POST",
          data: { email: $('#CustomerEmail').val() },
          crossDomain: true,
          success: function (response) {
              console.log(response);
              if(response == 'invited'){                
                  $('#loginInviteSuccess').removeClass('hide');
                  $('#btnSignin').removeAttr("disabled");
              } else {
                  //$('#customer_login').unbind('submit').submit();
                  $("#customer_login").submit();
              }
          },
          error: function (xhr, status) {
              console.log('Ajax call error: '+status);
              $('#btnSignin').removeAttr("disabled");
          }
      });
  });
  $('#btnRecoverPwd').on('click', function(e){
      $('#btnRecoverPwd').attr("disabled", true);
      $('#ResetSuccess').addClass('hide');
      $('.form-message').addClass('hide');
      $.ajax({
          url: "https://app.dimplecontacts.com/middleware/subscription/checkcustomerlogin",
          type: "POST",
          data: { email: $('#RecoverEmail').val() },
          crossDomain: true,
          success: function (response) {
              console.log(response);
              if(response == 'invited'){
                  $('.recover-subtext').addClass('hide');
                  $('#recoverInviteSuccess').removeClass('hide');
                  $('#btnRecoverPwd').removeAttr("disabled");
              } else {
                 // $('#RecoverPasswordForm form').unbind('submit').submit();
                 $('#RecoverPasswordForm form').submit();
              }
          },
          error: function (xhr, status) {
              console.log('Ajax call error: '+status);
              $('#btnRecoverPwd').removeAttr("disabled");
          }
      });
  });
});
// Window Load ----------------------------------
$(window).load(function() {

    var wowClass = check('.wow');
    if (wowClass > 0) {
        wow = new WOW({
            boxClass: 'wow', // default
            animateClass: 'animated', // default
            offset: 0, // default
            mobile: false, // default
            live: true // default
        })
        wow.init();
    }
    // Klaviyo Overwrite scripts ---------------------------
    setTimeout(function() {
        $("div.klaviyo-form input[type='text'], div.klaviyo-form input[type='email']").on("focus", function() {
            $(this).parents("div.klaviyo-form").stop().addClass("is-focus");
        }).blur(function() {
            $(this).parents("div.klaviyo-form").stop().removeClass("is-focus");
            var errorAttribute = $(this).attr('valid');
            if (errorAttribute == 0) {
                $(this).addClass('error');
            }
        });
        $("div.klaviyo-form  input[type='text'], div.klaviyo-form input[type='email']").keypress(function(e) {
            var key = e.which;
            if (key == 13) {
                $(this).parents("div.klaviyo-form").find('button').click();
            }
        });
    }, 1000);
    setTimeout(function() {
        $("a.stamped-summary-actions-newreview").on("click", function() {
            $(".stamped-form-contact-name input").focus();
            var formOffsetTop = $(".stamped-form-contact-name input").offset().top;
            $("body, html").animate({
                scrollTop: formOffsetTop - 80
            });
        });
    }, 2500);
  	setTimeout(function() {
        var rating = $('.reviews .stamped-badge-caption').data('rating');
        var reviews = $('.reviews .stamped-badge-caption').data('reviews');
        $('.reviews .stamped-badge-caption').html(reviews+' reviews ('+rating+'/5 rating)');
        if(rating >= 4.75){
            $('.reviews .stamped-fa-star-half-o').removeClass('stamped-fa-star-half-o').addClass('stamped-fa-star');
        }
        $('.reviews').css('opacity', 1);
    }, 3000);
});

function check(type) {
    return $('body').find(type).length;
}
// Help Page Scroll Script for Desktop and Mobile ----------------------
function scroller() {
    var winWidth = $(window).width();
    if (winWidth >= 768) {
        $("div.scroller").removeClass("mobile-view").addClass("desktop-view");
    } else {
        $("div.scroller").removeClass("desktop-view").addClass("mobile-view");
    }
    var mobileNavHeight = $("nav.scroller-nav-mobile").innerHeight();
    $("div.scroller.mobile-view").css('height', mobileNavHeight);
    $("div.scroller.desktop-view nav.scroller-nav ul li span").on('click', function(e) {
        $("div.scroller-content").addClass('scroll-active');
        e.preventDefault();
        $("div.scroller.desktop-view nav.scroller-nav ul li").removeClass('active');
        $(this).parents("li").addClass('active');
        var currentId = $(this).attr('data-id'),
            headerHeight = $("header.site-header").innerHeight(),
            scrollPos = $(currentId).offset().top;
        $("div.scroller-content div.scroller-item").removeClass('current');
        $(currentId).addClass("current");
        location.hash = currentId;
    });
    if ($('#sticky').length) { // make sure "#sticky" element exists
        var el = $('#sticky');
        var stickyTop = $('#sticky').offset().top; // returns number
        var stickyHeight = $('#sticky').height();
        $(window).scroll(function() { // scroll event
            var limit = $('footer.site-footer').offset().top - stickyHeight - 20;
            var windowTop = $(window).scrollTop(); // returns number
            if (stickyTop < windowTop + 80) {
                $("div.scroller-content").addClass('scroll-active');
                el.css({
                    position: 'fixed',
                    top: '80px'
                });
            } else {
                $("div.scroller-content").removeClass('scroll-active');
                el.css('position', 'static');
            }
            if (limit < windowTop) {
                var diff = limit - windowTop;
                el.css({
                    top: diff
                });
            }
        });
    }
    $("nav.scroller-nav-mobile ul li span").on("click", function() {
        var itemDataId = $(this).attr('data-id');
        $("div.scroller.mobile-view div.scroller-content div.scroller-item").removeClass('mobile-visible');
        $("#" + itemDataId).addClass("mobile-visible");
        $("nav.scroller-nav-mobile").addClass('slide');
        $("div.scroller.mobile-view div.scroller-content").addClass('slide');
        backTrigger();
        $("div.page-help .scroller").css("height", 'auto');
        var secScrollTop = $(".scroller-nav-mobile").offset().top;
        $("body, html").animate({
            scrollTop: secScrollTop - 80
        });
    });

    function backTrigger() {
        $("div.mobile-visible h2.title").on("click", function(e) {
            e.stopPropagation();
            $("div.scroller.mobile-view div.scroller-content").removeClass('slide');
            $("nav.scroller-nav-mobile").removeClass('slide');
            var mobileNavHeight = $("nav.scroller-nav-mobile").innerHeight();
            $("div.scroller.mobile-view").css('height', mobileNavHeight);
            setTimeout(function() {
                $("div.scroller.mobile-view div.scroller-content div.scroller-item").removeClass('mobile-visible');
            }, 500);
        });
    }
}

if (!window.IntersectionObserver) {
    $("img.lazyimg").each(function(){
        var dataImg = $(this).attr('data-lazy');
       $(this).attr('src', dataImg );
    });
} else {
  $("img.lazyimg").each(function(){
        var dataImg = $(this).attr('data-lazy');
       $(this).attr('src', dataImg );
    });
    // Do regular loading with IntersectionObserver
//     var lazyimg = check('.lazyimg');
//     if (lazyimg > 0) {

//     const targets = document.querySelectorAll("img.lazyimg");
//     const lazyLoad = target => {
//         const io = new IntersectionObserver((entries, observer) =>{
//            entries.forEach(entry =>{
//              console.log(1);
//              if(entry.isIntersecting){
//                 const img = entry.target;
//                 const src = img.getAttribute('data-lazy');

//                 img.setAttribute('src', src);
//                 img.classList.add('fade');

//                 observer.disconnect();
//              }
//            });
//            threshold: [0]
//         });

//         io.observe(target);
//     };

//     targets.forEach(lazyLoad);
//     }
}
